var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleform = function SvgSimpleform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M30.5 7h-29a.5.5 0 1 1 0-.999h29a.5.5 0 1 1 0 1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M1.5 22A.5.5 0 0 1 1 21.5v-18C1 2.673 1.673 2 2.5 2h27c.827 0 1.5.673 1.5 1.501v9a.5.5 0 0 1-1 0v-9c0-.275-.224-.5-.5-.5h-27c-.276 0-.5.225-.5.5v18a.5.5 0 0 1-.5.499M22 31H10.5a.5.5 0 1 1 0-1h1c.827 0 1.5-.672 1.5-1.499v-1a.5.5 0 0 1 1 0v1c0 .562-.187 1.082-.501 1.5h5.002a2.5 2.5 0 0 1-.5-1.5v-3a.5.5 0 1 1 .999 0v3c0 .827.673 1.5 1.5 1.5H22A.5.5 0 1 1 22 31",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M18.5 26.001h-16c-.827 0-1.5-.673-1.5-1.501V21.5a.5.5 0 0 1 .5-.5h14a.5.5 0 1 1 0 .999H2v2.5c0 .275.224.5.5.5h16a.5.5 0 1 1 0 1.001M7.5 14h-3a.5.5 0 1 1 0-1h3a.5.5 0 0 1 0 1M14.5 10.001h-10a.5.5 0 1 1 0-1h10a.5.5 0 0 1 0 1M14.5 12h-10a.5.5 0 1 1 0-1h10a.5.5 0 0 1 0 1",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBC8F2",
    fillRule: "evenodd",
    d: "M25 14.501a6.5 6.5 0 0 0-6.5 6.5c0 1.539.538 2.952 1.434 4.066A6.5 6.5 0 0 0 30.5 20a6.47 6.47 0 0 0-1.433-4.066A6.47 6.47 0 0 0 25 14.5",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M24 27c-3.86 0-7-3.139-7-7 0-3.86 3.14-7 7-7 1.352 0 2.663.387 3.792 1.116a.5.5 0 0 1-.543.84A5.96 5.96 0 0 0 24 14.001c-3.309 0-6 2.69-6 5.999a6.01 6.01 0 0 0 6 6.001 6.008 6.008 0 0 0 5.7-7.877.501.501 0 0 1 .95-.313A7.007 7.007 0 0 1 24 27",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#867CFC",
    fillRule: "evenodd",
    d: "M23.5 22.7h-.012a.5.5 0 0 1-.373-.18l-2.5-3a.5.5 0 0 1 .77-.64l2.132 2.56 6.215-6.865a.5.5 0 1 1 .736.675l-6.599 7.288a.5.5 0 0 1-.37.162",
    clipRule: "evenodd"
  })));
};
export default SvgSimpleform;